import { AxiosError } from 'axios';

import logAjaxError from '@/utils/logAjaxError';
import { LoggedOutError } from '@/utils/LoggedOutError';
import { errorMessage } from '@/utils/mapAxiosErrorMessages';

const defaultRepositoryError = async (error: AxiosError, errorMessagePrefix = '') => {
  if (error instanceof LoggedOutError) return Promise.reject(error);
  logAjaxError(error);

  const message = `${errorMessagePrefix ? errorMessagePrefix : ''} ${errorMessage(error)}`;
  await Promise.reject(message);

  return {
    errorMessage: message,
    error: error,
    isError: true
  };
};

export default defaultRepositoryError;
